import api from '../modules/api';
import CONSTANTS from '../constants';
import { yearDifference, converteStringDataDDMMYYYYParaDate, tirarAcento } from '../modules/util';
import { _mapearPropriedadesPessoa, _createStatePessoa } from '../modules/api';
let _timerError = -1;

var actions = {
    setError(error) {
        return (dispatch) => {
            dispatch({
                type: CONSTANTS.SET_ERROR,
                error: true,
                payload: error
            });

            clearTimeout(_timerError);
            _timerError = setTimeout(() => {
                dispatch({
                    type: CONSTANTS.SET_ERROR,
                    error: false,
                    payload: ""
                });
            }, 10000);
        };
    },

    onChangeIsAlteracao(isAlteracao) {
        return {
            type: CONSTANTS.SET_IS_ALTERACAO,
            payload: isAlteracao
        };
    },

    handleChangeCaptcha(captcha) {
        return {
            type: CONSTANTS.CHANGE_CAPTCHA,
            payload: captcha
        };
    },

    setAceiteRegulamento(aceite) {
        return {
            type: CONSTANTS.SET_ACEITE_REGULAMENTO,
            payload: aceite
        };
    },

    setAceite(aceite) {
        return {
            type: CONSTANTS.SET_ACEITE,
            payload: aceite
        };
    },

    setAba(index) {
        return {
            type: CONSTANTS.SET_ABA,
            payload: {
                index: index
            }
        };
    },

    getDadosParaAlteracao() {
        return (dispatch, getState) => {

            var state = getState().solicitacao;
            dispatch({
                type: CONSTANTS.GET_DADOS_ALTERACAO.LOADING
            });
            api.getDadosParaAlteracao(state.alteracao.pesCPF)
                .then((dados) => {
                    if (dados.possuiCadastro) {
                        dispatch(actions.getCidadesByUf(dados.dados[0].loc_uf));
                    }
                    var listArquivosGrupoFamiliarSeq = dados.listArquivosGrupoFamiliarSeq;

                    listArquivosGrupoFamiliarSeq = listArquivosGrupoFamiliarSeq.map((item) => {
                        return new Promise((resolve, reject) => {
                            api.getArquivo(dados.solSeqCript2, item).then(resolve).catch(reject);
                        });
                    });
                    dados.listArquivosGrupoFamiliar = [];
                    if (listArquivosGrupoFamiliarSeq.length === 0) {
                        dispatch({
                            type: CONSTANTS.GET_DADOS_ALTERACAO.SUCCESS,
                            payload: dados
                        });
                        return;
                    }

                    return Promise.all(listArquivosGrupoFamiliarSeq).then((listArquivosGrupoFamiliar) => {
                        dados.listArquivosGrupoFamiliar = listArquivosGrupoFamiliar;
                        dispatch({
                            type: CONSTANTS.GET_DADOS_ALTERACAO.SUCCESS,
                            payload: dados
                        });
                    });

                })
                .catch((err) => {
                    dispatch({
                        type: CONSTANTS.GET_DADOS_ALTERACAO.ERROR,
                        error: true,
                        payload: err
                    });
                    dispatch(actions.setError(err));
                });
        };
    },

    onChangeMotivo(value) {
        return {
            type: CONSTANTS.CHANGE_MOTIVO,
            payload: value
        }
    },

    changeCampoGenericoAlteracao(campoState, valor) {
        return {
            type: CONSTANTS.CHANGE_ALTERACAO_GENERICO,
            payload: {
                campoState: campoState,
                valor: valor
            }
        };
    },

    validaStepGrupoFamiliar(dispatch, getState) {
        var state = getState().solicitacao.grupoFamiliar;

        if (!state.solTpMoradia) {
            dispatch(this.setError(new Error("Informe condições de moradia")));
            return false;
        }
        return true;
    },

    validaStepCursoInteresse(dispatch, getState) {
        var state = getState().solicitacao.cursoInteresse;

        if (state.perSeq <= 0 ||
            !state.curCodigo ||
            !state.polCodigo ||
            !state.perPeriodo ||
            !state.maximoPercent ||
            !state.solPercentual ||
            !state.solMotivo.trim()
        ) {
            dispatch(this.setError(new Error("Informe todos os campos para continuar")));
            return false;
        }
        return true;
    },

    validaStepDadosInteressado(dispatch, getState) {
        var state = getState().solicitacao.dadosInteressado;
        var erros = {
            uf: false,
            locCodigo: false,
            pesCPF: false,
            pesNome: false,
            emlEmail: false,
            pesRG: false,
            pesEstExp: false,
            pesOrgExp: false,
            pesSexo: false,
            pesTelefone: false,
            pesCelular: false,
            pesBairro: false,
            pesCEP: false,
            pesRua: false,
            solAnoConcl2g: false,
            solRede2g: false,
            pesEstCiv: false,
            pesDtNasc: false,
            possuiAlgumaDeficiencia: false,
            solEnem: false,
            solCursoSup: false
        };
        var especificoErro = "";
        var possuiErro = false;
        Object.keys(erros).forEach((item) => {
            if (item === 'pesTelefone' || item === 'pesCelular' ){
                if( !state.pesTelefone && !state.pesCelular) {
                    especificoErro = "Informe o  Telefone ou Celular";
                    possuiErro = true;
                    erros[item] = true;
                } 
            }else {
                if (!state[item]) {
                    possuiErro = true;
                    erros[item] = true;
                    //return;
                }
            }
           

            if (item === "pesRua" && !(/\d/.test(state["pesRua"]))) {
                especificoErro = "Informe o número de seu endereço";
                erros["pesRua"] = true;
                return;

            }

            if (item === "possuiAlgumaDeficiencia" && state[item] === "S" &&
                !state.tdfCodigo) {
                especificoErro = "Selecione a deficiência";
                erros["tdfCodigo"] = true;
                return;
            }
            //fez enem?
            if (item === "solEnem" && state["solEnem"] === "S") {
                if (!state.solAnoEnem || state.solAnoEnem <= 0) {
                    especificoErro = "Informe  Ano do Último ENEM realizado";
                    erros.solEnem = true;
                    return;
                }
                if (!state.solPontEnem || state.solPontEnem <= 0) {
                    especificoErro = "Informe Pontuação do ENEM";
                    erros.solEnem = true;
                    return;
                }
            }

            if (item === "solCursoSup" && state.solCursoSup === "S" && !state.solNomeCursoSup) {
                erros.solNomeCursoSup = true;
                especificoErro = "Informe Nome Curso Superior";
                return;
            }
            //casado
            if (item === "pesEstCiv" && state.pesEstCiv === 2) {
                if (!state.conjugePesCPF ||
                    !state.conjugePesNome ||
                    !state.conjugePesDtNasc ||
                    !state.conjugePesRG ||
                    !state.conjugePesSexo ||
                    (!state.conjugePesTelefone && !state.conjugePesCelular)) {
                    especificoErro = "Informe  campos do Cônjuge";
                    erros.conjugePesCPF = true;
                    return;
                }
            }

        });


        if (possuiErro || especificoErro) {
            dispatch(this.setError(new Error(especificoErro || "Informe todos os campos para continuar")));
            dispatch({
                type: CONSTANTS.ERROR_INTERESSADO,
                payload: erros
            });
            return false;
        }
        return true;
    },

    nextStep() {
        return (dispatch, getState) => {
            var activeStep = getState().solicitacao.activeStep;

            //validar
            if (activeStep === CONSTANTS._STEPS.CURSO_INTERESSE.index &&
                !this.validaStepCursoInteresse(dispatch, getState)) {
                return;
            }

            if (activeStep === CONSTANTS._STEPS.DADOS_INTERESSADO.index &&
                !this.validaStepDadosInteressado(dispatch, getState)) {
                return;
            }

            if (activeStep === CONSTANTS._STEPS.DADOS_GRUPO_FAMILIAR.index &&
                !this.validaStepGrupoFamiliar(dispatch, getState)) {
                return;
            }


            dispatch({
                type: CONSTANTS.NEXT_STEP
            });
        };
    },

    backStep() {
        return {
            type: CONSTANTS.BACK_STEP
        };
    },

    onFinalizar() {
        return (dispatch, getState) => {
            var state = getState().solicitacao;
            dispatch({
                type: CONSTANTS.FINALIZAR_CADASTRO.LOADING
            });
            var cursoInteresse = { ...state.cursoInteresse };
            delete cursoInteresse.listAllFinanciamentos;
            delete cursoInteresse.listCursos;
            delete cursoInteresse.listPolo;
            delete cursoInteresse.listPeriodo;
            var dadosInteressado = { ...state.dadosInteressado };
            delete dadosInteressado.listCidades;
            delete dadosInteressado.listDeficiencias;
            delete dadosInteressado.listEstados;
            var grupoFamiliar = { ...state.grupoFamiliar };
            delete grupoFamiliar.listTpMoradia;
            delete grupoFamiliar.listParentesco;
            grupoFamiliar.listFamiliar = grupoFamiliar.listFamiliar.map((item) => {
                if (item.famRendaBruta === "") {
                    item.famRendaBruta = "0";
                }
                return item;
            });
            var listArquivosGrupoFamiliar = grupoFamiliar.listArquivosGrupoFamiliar;
            delete grupoFamiliar.listArquivosGrupoFamiliar;
            dispatch({
                payload: { msg: 'Finalizando...' },
                type: CONSTANTS.PROGRESS_FINALIZAR_CADASTRO
            });
            api.finalizarFinanciamentoInterno(state.captcha, state.solSeq, cursoInteresse, dadosInteressado, grupoFamiliar)
                .then(({ msg, solSeqCript2 }) => {
                    dispatch({
                        payload: { msg: 'Iniciando envio de ' + listArquivosGrupoFamiliar.length + ' arquivos' },
                        type: CONSTANTS.PROGRESS_FINALIZAR_CADASTRO
                    });
                    return api.gravaArquivos(solSeqCript2, 'G', listArquivosGrupoFamiliar, (item) => {
                        dispatch({
                            payload: { msg: 'Arquivo ' + item.UplDescricao + ' enviado com sucesso. Aguarde...' },
                            type: CONSTANTS.PROGRESS_FINALIZAR_CADASTRO
                        });
                    }).then((a) => {
                        dispatch({
                            payload: msg,
                            type: CONSTANTS.FINALIZAR_CADASTRO.SUCCESS
                        });
                    });
                })
                .catch((err) => {
                    var src = document.querySelector("#imgCaptchaFinanciamento").src;
                    document.querySelector("#imgCaptchaFinanciamento").src = src + "&cache=" + Date.now();

                    dispatch({
                        type: CONSTANTS.FINALIZAR_CADASTRO.ERROR,
                        error: true,
                        payload: err
                    });
                    dispatch(actions.setError(err));
                });
        };
    },

    getPerSeq(listAllFinanciamentos, curCodigo, perPeriodo, polCodigo) {
        for (var i = 0; i < listAllFinanciamentos.length; i++) {
            var item = listAllFinanciamentos[i];
            if (item.cur_codigo == curCodigo &&
                item.per_periodo == perPeriodo &&
                item.pol_codigo == polCodigo) {
                return {
                    per_maxpercent: item.per_maxpercent,
                    per_seq: item.per_seq,
                    per_dtfim: item.per_dtfim
                };
            }
        }
        return {
            per_seq: 0,
            per_dtfim: ''
        };
    },

    changeCurso(curCodigo) {
        return (dispatch, getState) => {
            var ci = getState().solicitacao.cursoInteresse;
            var listAllFinanciamentos = ci.listAllFinanciamentos;
            var c = api.getCursoByCurCodigo(listAllFinanciamentos, curCodigo) || {};
            let p = this.getPerSeq(listAllFinanciamentos, curCodigo, ci.perPeriodo, ci.polCodigo);
            dispatch({
                type: CONSTANTS.CHANGE_CURSO,
                payload: {
                    perDtFim: p.per_dtfim,
                    perSeq: p.per_seq,
                    curURL: (c.cur_url || "").trim(),
                    curCodigo: curCodigo,
                    listPeriodo: api.getPeriodosByCurso(listAllFinanciamentos, curCodigo)
                }
            });
        }
    },

    changePeriodo(perPeriodo) {
        return (dispatch, getState) => {
            var c = getState().solicitacao.cursoInteresse;
            var listAllFinanciamentos = c.listAllFinanciamentos;
            var curCodigo = c.curCodigo;
            let p = this.getPerSeq(listAllFinanciamentos, c.curCodigo, perPeriodo, c.polCodigo);

            dispatch({
                type: CONSTANTS.CHANGE_PERIODO,
                payload: {
                    perDtFim: p.per_dtfim,
                    perSeq: p.per_seq,
                    perPeriodo: perPeriodo,
                    listPolo: api.getPolosByCursoPeriodo(listAllFinanciamentos, curCodigo, perPeriodo)
                }
            });
        }
    },

    changePolo(polCodigo) {
        return (dispatch, getState) => {
            var c = getState().solicitacao.cursoInteresse;
            var listAllFinanciamentos = c.listAllFinanciamentos;
            var polo = api.getPoloByPolCodigo(listAllFinanciamentos, polCodigo) || {};
            let p = this.getPerSeq(listAllFinanciamentos, c.curCodigo, c.perPeriodo, polCodigo);
            dispatch({
                type: CONSTANTS.CHANGE_POLO,
                payload: {
                    perDtFim: p.per_dtfim,
                    perSeq: p.per_seq,
                    maximoPercent: p.per_maxpercent || 0,
                    polCodigo: polCodigo
                }
            });
        }
    },

    onChangePercentDesejado(solPercentual) {
        return (dispatch, getState) => {
            var c = getState().solicitacao.cursoInteresse;
            solPercentual = Number(solPercentual);
            if (solPercentual > c.maximoPercent) {
                solPercentual = c.maximoPercent;
            }
            if (solPercentual < 0) {
                solPercentual = 0;
            }
            dispatch({
                type: CONSTANTS.CHANGE_PERCENTDESEJADO,
                payload: {
                    solPercentual: solPercentual
                }
            });
        }
    },

    carregarFinanciamentosdisponiveis() {
        return (dispatch, getState) => {
            dispatch(this.getListTpMoradia());
            dispatch(this.getListParentesco());

            var c = getState().solicitacao.cursoInteresse;
            var listAllFinanciamentos = c.listAllFinanciamentos;
            if (listAllFinanciamentos.length > 0) {
                console.log("ja carregou");
                return;
            }
            dispatch({
                type: CONSTANTS.CARREGAR_FINANCIAMENTOS_DISPONIVEIS.LOADING
            });
            api.carregarFinanciamentosdisponiveis().then((response) => {
                dispatch({
                    type: CONSTANTS.CARREGAR_FINANCIAMENTOS_DISPONIVEIS.SUCCESS,
                    payload: response
                });
            }).catch((error) => {
                console.error(error);
                var err = new Error("Erro ao carregar financiamentos");
                dispatch({
                    type: CONSTANTS.CARREGAR_FINANCIAMENTOS_DISPONIVEIS.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });
        };
    },

    changeCampoGenericoInteressado(campoState, valor) {
        if (campoState === "pesCPF") {
            valor = Number(valor.replace(/[^\d]/gim, '')) || 0;
        }

        return {
            type: CONSTANTS.CHANGE_CAMPO_GENERICO_INTERESSADO,
            payload: {
                campoState: campoState,
                valor: valor
            }
        };
    },

    getDadosInteressadoCPF(cpf) {
        return (dispatch, getState) => {
            dispatch({
                type: CONSTANTS.GET_DADOS_INTERESSADO_CPF.LOADING
            });
            //caso ja possui solicitacao entao não pode
            api.aindaNaoPossuiCadastro(cpf).then(() => {
                api.getPessoasPorCpf(cpf).then((response) => {
                    dispatch({
                        type: CONSTANTS.GET_DADOS_INTERESSADO_CPF.SUCCESS,
                        payload: response
                    });
                    if (response.dadosPessoa) {
                        dispatch(actions.getCidadesByUf(response.dadosPessoa.LocUf));
                    }
                }).catch((error) => {
                    console.error(error);
                    var err = (error || new Error("Erro ao carregar cpf"));
                    dispatch({
                        type: CONSTANTS.GET_DADOS_INTERESSADO_CPF.ERROR,
                        error: true,
                        payload: err
                    });
                    dispatch(actions.setError(err));
                });
            }).catch((error) => {
                dispatch({
                    type: CONSTANTS.GET_DADOS_INTERESSADO_CPF.ERROR,
                    error: true,
                    payload: error
                });
                dispatch(actions.setError(new Error(error)));
            });
        };
    },

    getDadosInteressadoConjugeCPF(cpf) {
        return (dispatch, getState) => {
            var state = getState().solicitacao.dadosInteressado;
            if (cpf == state.pesCPF) {
                var err = new Error("Erro CPF não pode ser o mesmo");
                dispatch({
                    type: CONSTANTS.GET_DADOS_INTERESSADO_CONJUGE_CPF.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
                return;
            }
            dispatch({
                type: CONSTANTS.GET_DADOS_INTERESSADO_CONJUGE_CPF.LOADING
            });
            api.getPessoasPorCpf(cpf).then((response) => {
                dispatch({
                    type: CONSTANTS.GET_DADOS_INTERESSADO_CONJUGE_CPF.SUCCESS,
                    payload: response
                });
            }).catch((error) => {
                console.error(error);
                var err = (error || new Error("Erro ao carregar GET_DADOS_INTERESSADO_CONJUGE_CPF"));
                dispatch({
                    type: CONSTANTS.GET_DADOS_INTERESSADO_CONJUGE_CPF.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });
        };
    },

    getListDeficiencia() {
        return (dispatch, getState) => {
            dispatch({
                type: CONSTANTS.CARREGAR_LIST_DEFICIENCIA.LOADING
            });
            api.getListDeficiencia().then((response) => {
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_DEFICIENCIA.SUCCESS,
                    payload: response
                });
            }).catch((error) => {
                console.error(error);
                var err = new Error("Erro ao carregar getListDeficiencia");
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_DEFICIENCIA.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });
        };
    },


    getListParentesco() {
        return (dispatch, getState) => {
            dispatch({
                type: CONSTANTS.CARREGAR_LIST_PARENTESCO.LOADING
            });
            api.getListParentesco().then((response) => {
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_PARENTESCO.SUCCESS,
                    payload: response
                });
            }).catch((error) => {
                console.error(error);
                var err = new Error("Erro ao carregar CARREGAR_LIST_PARENTESCO");
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_PARENTESCO.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });
        };
    },



    getListTpMoradia() {
        return (dispatch, getState) => {
            dispatch({
                type: CONSTANTS.CARREGAR_LIST_TPMORADIA.LOADING
            });
            api.getListTpMoradia().then((response) => {
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_TPMORADIA.SUCCESS,
                    payload: response
                });
            }).catch((error) => {
                console.error(error);
                var err = new Error("Erro ao carregar CARREGAR_LIST_TPMORADIA!!!");
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_TPMORADIA.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });
        };
    },


    getNacionalidade() {
        return (dispatch, getState) => {
            dispatch({
                type: CONSTANTS.CARREGAR_LIST_NACIONALIDADE.LOADING
            });
            api.getNacionalidade().then((response) => {
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_NACIONALIDADE.SUCCESS,
                    payload: response
                });
            }).catch((error) => {
                console.error(error);
                var err = new Error("Erro ao carregar CARREGAR_LIST_NACIONALIDADE!!!");
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_NACIONALIDADE.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });
        };
    },



    getCidadesByUf(uf) {
        return (dispatch, getState) => {
            dispatch({
                type: CONSTANTS.CARREGAR_LIST_CIDADES.LOADING
            });
            api.getCidadesByUf(uf).then((response) => {
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_CIDADES.SUCCESS,
                    payload: response
                });
            }).catch((error) => {
                console.error(error);
                var err = new Error("Erro ao carregar getCidadesByUf");
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_CIDADES.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });
        };
    },

    consultaCEP(cep) {
        return (dispatch, getState) => {
            if (cep.length < 8 || cep.length > 9) {
                return;
            }
            dispatch({
                type: CONSTANTS.CONSULTA_CEP.LOADING
            });
            api.consultaCEP(cep).then((response) => {
                /*
                bairro : "Parque Residencial Servantes"
                cidade : "Presidente Prudente" 
                complemento : "" 
                complemento2 : "" 
                rua : "Rua Isaac Melem" 
                uf : "SP
                */
                if (response.uf) {
                    api.getCidadesByUf(response.uf).then((list) => {
                        response.listCidades = list;
                        var listTemp = list.filter((item) => {
                            return  tirarAcento(item.loc_nome.trim()) === tirarAcento(response.cidade.toUpperCase().trim());
                        });
                        if (listTemp.length > 0) {
                            response.locCodigo = listTemp[0].loc_codigo;
                        }
                        dispatch({
                            type: CONSTANTS.CONSULTA_CEP.SUCCESS,
                            payload: response
                        });
                    });
                } else {
                    dispatch({
                        type: CONSTANTS.CONSULTA_CEP.SUCCESS,
                        payload: response
                    });
                }
            }).catch((error) => {
                console.error(error);
                var err = new Error(error.message || "Erro ao carregar CONSULTA_CEP");
                dispatch({
                    type: CONSTANTS.CONSULTA_CEP.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });
        };
    },

    onEditarCPF() {
        return {
            type: CONSTANTS.EDITAR_CPF
        };
    },
    onEditarConjugeCPF() {
        return {
            type: CONSTANTS.CONJUGE_EDITAR_CPF
        };
    },
    changeCampoGenericoFamiliar(campoState, valor) {
        return {
            type: CONSTANTS.CHANGE_CAMPO_GENERICO_GRUPO_FAMILIAR,
            payload: {
                campoState: campoState,
                valor: valor
            }
        };
    },
    addPessoaGrupoFamiliar(pessoa) {
        return {
            type: CONSTANTS.ADD_PESSOA_NO_GRUPO_FAMILIAR,
            payload: pessoa
        };
    },
    deletePessoaGrupoFamiliar(indice) {
        return {
            type: CONSTANTS.DELETE_PESSOA_NO_GRUPO_FAMILIAR,
            payload: {
                indice: indice
            }
        };
    },

    updatePessoaGrupoFamiliar(indice, item) {
        return {
            type: CONSTANTS.UPDATE_PESSOA_NO_GRUPO_FAMILIAR,
            payload: {
                indice: indice,
                item: item
            }
        };
    },


    addCadastroNoGrupoFamiliar() {
        return (dispatch, getState) => {
            var dadosInteressado = getState().solicitacao.dadosInteressado;
            var grupoFamiliar = getState().solicitacao.grupoFamiliar;
            var possuiConjuge = dadosInteressado.pesEstCiv === 2;

            var list = [];


            var idade = yearDifference(converteStringDataDDMMYYYYParaDate(dadosInteressado.pesDtNasc));
            list.push({
                isCadastro: true,
                famNome: dadosInteressado.pesNome,
                famIdade: idade,
                famCpf: dadosInteressado.pesCPF,
                famParentesco: "",
                famEscolaridade: dadosInteressado.solCursoSup === "S" ? 3 : 0,
                famProfissao: dadosInteressado.pesCargo,
                famRendaBruta: dadosInteressado.pesRendaBruta
            });
            if (possuiConjuge) {
                list.push({
                    isCadastro: true,
                    famNome: dadosInteressado.conjugePesNome,
                    famIdade: yearDifference(converteStringDataDDMMYYYYParaDate(dadosInteressado.conjugePesDtNasc)),
                    famCpf: dadosInteressado.conjugePesCPF,
                    famParentesco: 5,
                    famEscolaridade: 0,
                    famProfissao: dadosInteressado.conjugePesCargo,
                    famRendaBruta: dadosInteressado.conjugePesRendaBruta
                });
            }

            //sempre diexa o autor do cadastro e seu conjuge em primeiro
            dispatch({
                type: CONSTANTS.SET_LIST_GRUPO_FAMILIAR,
                payload: [...list, ...(grupoFamiliar.listFamiliar.filter((item) => {
                    return !item.isCadastro;
                }))]
            });
        };
    },

    setIndexAbaFiador(index) {
        return (dispatch, getState) => {
            var fiadores = getState().fiadores;
            var precisaResponsavel = _precisaResponsavel(fiadores);
            if (precisaResponsavel && index == 1) {
                dispatch(this.setError(new Error("Informe os dados do Responsável")));
                return false;
            }

            console.log('----------------------------');
            if (document.querySelector(".root-financiamento-interno-scroll")) {
                console.log('--------scrollView------');
                document.querySelector(".root-financiamento-interno-scroll").scrollIntoView({ behaviour: "smooth" });
            }

            dispatch({
                type: CONSTANTS.SET_INDEX_ABAFIADOR,
                payload: {
                    indexAbaFiador: index
                }
            });
        }
    },

    changeCampoGenericoFiador(campoState, valor, tipoPessoa, indiceFiador) {
        return {
            type: CONSTANTS.CHANGE_CAMPO_GENERICO_FIADOR,
            payload: {
                campoState: campoState,
                valor: valor,
                tipoPessoa: tipoPessoa,
                indiceFiador: indiceFiador
            }
        };
    },

    mapPessoa(dispatch, itemPessoa, tipoPessoa, indiceFiador) {
        if (!itemPessoa) {
            return null;
        }
        let servidorParaClient = true;
        itemPessoa = _mapearPropriedadesPessoa(itemPessoa, servidorParaClient);
        if (itemPessoa.uf) {
            dispatch(actions.getCidadesByUfFiador(itemPessoa.uf, tipoPessoa, indiceFiador));
        }
        if (itemPessoa.conjuge && itemPessoa.conjuge.uf) {
            dispatch(actions.getCidadesByUfFiador(itemPessoa.conjuge.uf, tipoPessoa, indiceFiador));
        }
        return itemPessoa;
    },

    getDadosFormFiadores() {
        return (dispatch, getState) => {
            dispatch({
                type: CONSTANTS.GET_DADOS_FORM_FIADORES.LOADING
            });
            dispatch(this.getListTpMoradia());
            api.getDadosFormFiadores().then((response) => {
                var solSeqCript2 = response.solSeqCript2;
                var maiorDeIdade = response.dadosSolicitacao.maiorDeIdade;
                var dadosResponsavel = response.dadosResponsavel && response.dadosResponsavel.length > 0 ? response.dadosResponsavel[0] : null;
                response.dadosResponsavel = this.mapPessoa(dispatch, dadosResponsavel, CONSTANTS._TIPO_PESSOA.RESPONSAVEL);
                //se ja preencheu entao devemos deixar obrigatorio ter responsavel
                if (dadosResponsavel) {
                    maiorDeIdade = false;
                    response.dadosSolicitacao.maiorDeIdade = false;
                }
                response.listFiadores = response.listFiadores.map((item, indice) => {
                    return this.mapPessoa(dispatch, item, CONSTANTS._TIPO_PESSOA.FIADOR, indice);
                });

                if (response.listFiadores.length === 0) {
                    response.listFiadores = Array(CONSTANTS.NUMERO_DE_FIADORES).fill(_createStatePessoa(CONSTANTS._TIPO_PESSOA.FIADOR));
                }

                var listArquivosSeq = response.listArquivosSeq;


                dispatch({
                    type: CONSTANTS.SET_INDEX_ABAFIADOR,
                    payload: {
                        indexAbaFiador: maiorDeIdade ? 1 : 0
                    }
                });

                listArquivosSeq = listArquivosSeq.map((item) => {
                    return new Promise((resolve, reject) => {
                        api.getArquivo(solSeqCript2, item).then(resolve).catch(reject);
                    });
                });
                response.listArquivos = [];
                if (listArquivosSeq.length === 0) {
                    dispatch({
                        type: CONSTANTS.GET_DADOS_FORM_FIADORES.SUCCESS,
                        payload: response
                    });
                    return;
                }

                return Promise.all(listArquivosSeq).then((listArquivos) => {
                    response.listArquivos = listArquivos;
                    dispatch({
                        type: CONSTANTS.GET_DADOS_FORM_FIADORES.SUCCESS,
                        payload: response
                    });
                });


            }).catch((error) => {
                console.error(error);
                var err = error;
                dispatch({
                    type: CONSTANTS.GET_DADOS_FORM_FIADORES.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });
        };
    },

    addFormFiador() {
        return {
            type: CONSTANTS.ADD_FORM_FIADOR,
            payload: {
                fiador: _createStatePessoa(CONSTANTS._TIPO_PESSOA.FIADOR)
            }
        };
    },

    onRemoveFiador(indice) {
        return {
            type: CONSTANTS.REMOVE_FORM_FIADOR,
            payload: {
                indice
            }
        };
    },

    onEditarFiadorCPF(tipoPessoa, indiceFiador) {
        return {
            type: CONSTANTS.EDITAR_FIADOR_CPF,
            payload: {
                tipoPessoa, indiceFiador
            }
        };
    },

    getCidadesByUfFiador(uf, tipoPessoa, indiceFiador) {
        return (dispatch, getState) => {
            dispatch({
                type: CONSTANTS.CARREGAR_LIST_CIDADES_FIADOR.LOADING,
                payload: {
                    indiceFiador,
                    tipoPessoa
                }
            });
            api.getCidadesByUf(uf).then((response) => {
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_CIDADES_FIADOR.SUCCESS,
                    payload: {
                        listCidades: response,
                        indiceFiador,
                        tipoPessoa
                    }
                });
            }).catch((error) => {
                console.error(error);
                var err = new Error("Erro ao carregar getCidadesByUf");
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_CIDADES_FIADOR.ERROR,
                    error: true,
                    payload: {
                        indiceFiador,
                        tipoPessoa,
                        err
                    }
                });
                dispatch(actions.setError(err));
            });
        };
    },

    getDadosFormFiadoresCPF(cpf, tipoPessoa, indiceFiador) {
        return (dispatch, getState) => {
            var listFiadores = getState().fiadores.listFiadores;
            //validacao no responsavel e seu conjuge
            //.....
            /* MELHORAR  ESSA  VALIDACOES DE CPF 
             FALTA A  VALIDAR DO RESPONSAVEL E SEU  CONJUGE
             E SEREPETE ENTREALGUM
             PENSAR EM  ESQUEMA DE LISTpESSOAS  ....*/

            let err = null;
            //validacao nos fiadores e seus conjuges
            if (listFiadores.some((item, indice) => {
                if (!cpf) {
                    err = "Erro CPF não informado";
                    return true;
                }
                if (item.pesCPF === cpf && indice !== indiceFiador) {
                    err = "Erro CPF duplicado em fiadores";
                    return true;
                }
                //valida se o CPF ja tem em algum conjuge de FIADOR                
                if (item.conjuge && item.conjuge.pesCPF === cpf &&
                    indice !== indiceFiador) {
                    err = "Erro CPF duplicado em conjuge de fiadores";
                    return true;
                }
                //valida se o CPF ja tem em algum conjuge de FIADOR                
                if (item.conjuge && item.conjuge.pesCPF === cpf &&
                    indice === indiceFiador && tipoPessoa === CONSTANTS._TIPO_PESSOA.FIADOR) {
                    err = "Erro CPF duplicado fiador/conjuge ";
                    return true;
                }

                return false;
            })) {
                dispatch(actions.setError(new Error(err)));
                return;
            }

            dispatch({
                type: CONSTANTS.GET_DADOS_FORM_FIADORES_CPF.LOADING,
                payload: {
                    indiceFiador: indiceFiador,
                    tipoPessoa: tipoPessoa
                }
            });
            api.getPessoasPorCpf(cpf).then((response) => {
                dispatch({
                    type: CONSTANTS.GET_DADOS_FORM_FIADORES_CPF.SUCCESS,
                    payload: {
                        dados: response,
                        indiceFiador: indiceFiador,
                        tipoPessoa: tipoPessoa
                    }
                });
                //tipoPessoa
                if (response.dadosPessoaNormalizado) {
                    dispatch(actions.getCidadesByUfFiador(response.dadosPessoaNormalizado.uf, tipoPessoa, indiceFiador));
                }
            }).catch((error) => {
                console.error(error);
                var err = (error || new Error("Erro ao carregar cpf"));
                dispatch({
                    type: CONSTANTS.GET_DADOS_FORM_FIADORES_CPF.ERROR,
                    error: true,
                    payload: {
                        err,
                        indiceFiador: indiceFiador,
                        tipoPessoa: tipoPessoa
                    }
                });
                dispatch(actions.setError(err));
            });

        };
    },

    onConsultaFiadorCEP(cep, tipoPessoa, indiceFiador) {
        return (dispatch, getState) => {
            if (cep.length < 8 || cep.length > 9) {
                return;
            }
            dispatch({
                type: CONSTANTS.CONSULTA_CEP_FIADOR.LOADING,
                payload: {
                    tipoPessoa, indiceFiador
                }
            });
            api.consultaCEP(cep).then((response) => {
                if (response.uf) {
                    api.getCidadesByUf(response.uf).then((list) => {
                        response.listCidades = list;
                        var listTemp = list.filter((item) => {
                            return tirarAcento(item.loc_nome.trim()) === tirarAcento(response.cidade.toUpperCase().trim());
                        });
                        if (listTemp.length > 0) {
                            response.locCodigo = listTemp[0].loc_codigo;
                        }
                        dispatch({
                            type: CONSTANTS.CONSULTA_CEP_FIADOR.SUCCESS,
                            payload: {
                                dadosCEP: response,
                                tipoPessoa,
                                indiceFiador
                            }
                        });
                    });
                } else {
                    dispatch({
                        type: CONSTANTS.CONSULTA_CEP_FIADOR.SUCCESS,
                        payload: {
                            dadosCEP: response,
                            tipoPessoa,
                            indiceFiador
                        }
                    });
                }
            }).catch((error) => {
                console.error(error);
                var err = new Error(error.message || "Erro ao carregar CONSULTA_CEP_FIADOR");
                dispatch({
                    type: CONSTANTS.CONSULTA_CEP_FIADOR.ERROR,
                    error: true,
                    payload: {
                        err,
                        tipoPessoa,
                        indiceFiador
                    }
                });
                dispatch(actions.setError(err));
            });
        };
    },

    retornaErrosValidaPessoaGenerico(objPessoa, tipoPessoa) {

        var camposErros = {
            pesCPF: false,
            pesNome: false,
            pesRG: false,
            pesEstExp: false,
            pesOrgExp: false,
            pesTelefone: false,
            pesCelular: false,
            pesEstCiv: false,
            pesDtNasc: false,
            pesCEP: false,
            pesRua: false,
            pesSexo: false,
            pesBairro: false,
            uf: false,
            locCodigo: false,
            tipSeq: false //moradia
        };

        var especificoErro = "";
        var possuiErro = false;

        let camposOpcionais = [

        ];

        if (tipoPessoa === CONSTANTS._TIPO_PESSOA.CONJUGE) {
            camposOpcionais = [
                'uf',
                'locCodigo',
                'pesBairro',
                'pesCEP',
                'pesRua',
                'pesEstCiv',
                'tipSeq'// //moradia
            ];
        }

        possuiErro = Object.keys(camposErros).some((item) => {
            if (!objPessoa[item]) {
                if (camposOpcionais.indexOf(item) === -1) {
                    camposErros[item] = true;
                    return true;//tem erro
                }
                return false;
            }



            //casado
            if (tipoPessoa !== CONSTANTS._TIPO_PESSOA.CONJUGE) {
                if (item === "pesRua" && !(/\d/.test(objPessoa["pesRua"]))) {
                    especificoErro = "Informe o número do  endereço  [CPF = " + objPessoa.pesCPF + "]";
                    camposErros.pesRua = true;
                    return true;//tem erro
                }


                if (item === "pesEstCiv" && objPessoa.pesEstCiv === 2) {
                    if (!objPessoa.conjuge || !objPessoa.conjuge.pesCPF || !objPessoa.conjuge.pesNome) {
                        especificoErro = "Informe dados do Cônjuge do [CPF = " + objPessoa.pesCPF + "]";
                        camposErros.pesCPF = true;
                        return true;//tem erro
                    }
                    let erroConjuge = this.retornaErrosValidaPessoaGenerico(objPessoa.conjuge, CONSTANTS._TIPO_PESSOA.CONJUGE);
                    if (erroConjuge.erroMsg) {
                        especificoErro = erroConjuge.erroMsg;
                        camposErros.pesCPF = true;
                        return true;//tem erro
                    }
                }
            }

            return false;
        });

        let erroPadrao = "Informe todos os campos da pessoa " + (objPessoa.pesCPF ? "[CPF = " + objPessoa.pesCPF + "]" : "");
        return {
            erroMsg: possuiErro ? (especificoErro || erroPadrao) : "",
            campoErros: camposErros
        };
    },

    actionValidaValidaPessoaGenerico(dispatch, objPessoa, tipoPessoa, indiceFiador) {
        let erros = this.retornaErrosValidaPessoaGenerico(objPessoa, tipoPessoa);
        if (erros.erroMsg) {
            dispatch(this.setError(new Error(erros.erroMsg)));
            dispatch({
                type: CONSTANTS.ERROR_PESSOA_FIADOR,
                payload: {
                    campoErros: erros.campoErros,
                    indiceFiador,
                    tipoPessoa
                }
            });
            return false;
        } else {
            //limpa todos campos de erros 
            dispatch({
                type: CONSTANTS.ERROR_PESSOA_FIADOR_LIMPAR,
                payload: {
                    indiceFiador,
                    tipoPessoa
                }
            });
        }
        //sem erros
        return true;
    },

    onConcluirEnvioFiadores() {
        return (dispatch, getState) => {
            let state = getState();
            let fiadoresState = state.fiadores;
            let solSeq = fiadoresState.dadosSolicitacao.solSeq;
            let dadosResponsavel = fiadoresState.dadosResponsavel;
            let listFiadores = fiadoresState.listFiadores;
            let passouPelaValidacao = true;
            let listArquivos = fiadoresState.listArquivos;
            /*
                VALIDACOES
            */
            if (dadosResponsavel) {
                //RESPONSAVEL
                passouPelaValidacao = this.actionValidaValidaPessoaGenerico(
                    dispatch,
                    dadosResponsavel,
                    CONSTANTS._TIPO_PESSOA.RESPONSAVEL
                );
            }
            if (passouPelaValidacao) {
                if (listFiadores.length < CONSTANTS.NUMERO_DE_FIADORES) {
                    dispatch(this.setError(new Error('Quantidade de fiadores deve ser no mínimo: ' + CONSTANTS.NUMERO_DE_FIADORES)));
                    return;
                }
                if (listFiadores.some((fiador, indice) => {
                    return !fiador.pesCPF;
                })) {
                    dispatch(this.setError(new Error('Informe o CPF de todos fiadores ')));
                    return;
                }
                passouPelaValidacao = listFiadores.every((fiador, indice) => {
                    //FIADORES
                    let ok = this.actionValidaValidaPessoaGenerico(
                        dispatch,
                        fiador,
                        CONSTANTS._TIPO_PESSOA.FIADOR,
                        indice
                    );
                    return ok;
                });
            }
            if (!passouPelaValidacao) {
                return;
            }
            //============================
            dispatch({
                type: CONSTANTS.CONCLUIR_ENVIO_FIADORES.LOADING
            });

            api.concluirEnvioFiadores(solSeq, dadosResponsavel, listFiadores).then(({ solSeqCript2, msgSucesso }) => {
                dispatch({
                    payload: { msg: 'Iniciando envio de ' + listArquivos.length + ' arquivos' },
                    type: CONSTANTS.PROGRESS_FINALIZAR_FIADOR
                });
                return api.gravaArquivos(solSeqCript2, 'F', listArquivos, (item) => {
                    dispatch({
                        payload: { msg: 'Arquivo ' + item.UplDescricao + ' enviado com sucesso. Aguarde...' },
                        type: CONSTANTS.PROGRESS_FINALIZAR_FIADOR
                    });
                }).then((a) => {
                    dispatch({
                        type: CONSTANTS.CONCLUIR_ENVIO_FIADORES.SUCCESS,
                        payload: {
                            msgSucesso: msgSucesso
                        }
                    });
                });
            }).catch((err) => {
                dispatch(this.setError(err));
                dispatch({
                    type: CONSTANTS.CONCLUIR_ENVIO_FIADORES.ERROR
                });
            });
        };
    },

    //ADD_ITEM_ARQUIVO_FAMILIAR
    saveItemArquivoFamilia(descricao, arquivoBytes, indice) {
        return (dispatch) => {
            dispatch({
                type: indice >= 0 ? CONSTANTS.UPDATE_ITEM_ARQUIVO_FAMILIAR : CONSTANTS.ADD_ITEM_ARQUIVO_FAMILIAR,
                payload: {
                    indice: indice,
                    UplDescricao: descricao,
                    UplArquivo: arquivoBytes
                }
            });
        };
    },

    removeItemArquivoFamilia(indice) {
        if (!window.confirm('Deseja remover? ')) {
            return;

        }
        return (dispatch) => {
            dispatch({
                type: CONSTANTS.REMOVE_ITEM_ARQUIVO_FAMILIAR,
                payload: {
                    indice
                }
            });
        };
    },

    //ADD_ITEM_ARQUIVO_FAMILIAR
    saveItemArquivoFiador(descricao, arquivoBytes, indice) {
        return (dispatch) => {

            dispatch({
                type: indice >= 0 ? CONSTANTS.UPDATE_ITEM_ARQUIVO_FIADOR : CONSTANTS.ADD_ITEM_ARQUIVO_FIADOR,
                payload: {
                    indice: indice,
                    UplDescricao: descricao,
                    UplArquivo: arquivoBytes
                }
            });
        };
    },

    removeItemArquivoFiador(indice) {
        if (!window.confirm('Deseja remover? ')) {
            return;

        }
        return (dispatch) => {
            dispatch({
                type: CONSTANTS.REMOVE_ITEM_ARQUIVO_FIADOR,
                payload: {
                    indice
                }
            });
        };
    }


};


let _precisaResponsavel = (fiadores) => {
    var precisaResponsavel = !fiadores.dadosSolicitacao.maiorDeIdade && (
        !fiadores.dadosResponsavel || !fiadores.dadosResponsavel.pesNome);
    return precisaResponsavel;
};

export default actions;


// WEBPACK FOOTER //
// ./src/actions/index.js